import { render, staticRenderFns } from "./Header3.vue?vue&type=template&id=5a9f42c5&"
import script from "./Header3.vue?vue&type=script&lang=js&"
export * from "./Header3.vue?vue&type=script&lang=js&"
import style0 from "./Header3.vue?vue&type=style&index=0&lang=less&scope=true&"
import style1 from "./Header3.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports